import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep, isEqual } from 'lodash';
import { useState, useCallback } from 'react';
import { Button } from '../../../../../../ui/button/button';
import { DialogActions } from '../../../../../../../redux/dialog/dialog.action';
import { DatePicker } from '../../../../../../ui/date-picker/date-picker';
import { Select } from '../../../../../../ui/select/select';
import { MaintenanceSortState } from '../../../../../../../type/maintenance/maintenance.type';
import { CustomerDetailActions } from '../../../../../../../redux/customer-detail/customer-detail.action';
import { State } from '../../../../../../../redux/root.reducer';
import { useDidMount } from '../../../../../../../hooks/life-cycle';
import { Input } from '../../../../../../ui/input/input';
import { useAppSelector } from '../../../../../../../hooks/use-redux';
import { pulldown } from '../../../../../../../utilities/pulldown';
import { sortEmployee, changeStore } from '../../../../../../../utilities/sort-employee';

type Props = {
  callback: (sort:MaintenanceSortState) => void;
}

export const RefindMaintenanceTable = (props:Props) => {
  const { callback } = props;

  /* Hook */
  const dispatch = useDispatch();
  const sort = useSelector((state: State) => state.customerDetail.maintenanceSort, isEqual);
  const {
    storeList,
    employeeList,
  } = useAppSelector((v) => v.master);

  const [sortState, setSortState] = useState(cloneDeep(sort));

  /* Callback */
  const handleClickSearch = useCallback(() => {
    dispatch(DialogActions.pop());
    callback(sortState);
    dispatch(CustomerDetailActions.setMaintenanceSort(cloneDeep(sortState)));
  }, [callback, sortState]);

  const setState = useCallback((v: MaintenanceSortState) => {
    setSortState(cloneDeep(v));
  }, [dispatch]);

  return (
    <div className="refind_wrap">
      <div className="refind_body">
        <div className="item_wrap">
          <div className="item_box">
            <div className="item_head">対応</div>
            <Select
              className=""
              value={sortState.supported_kubun}
              defaultLabel="指定なし"
              onChange={(v) => {
                setState({ ...sortState, supported_kubun: Number(v) });
              }}
              options={[
                { text: '未対応', value: 1 },
                { text: '対応済み', value: 2 },
              ]}
            />
          </div>
          <div className="item_box">
            <div className="item_head">案件名</div>
            <Input
              value={sortState.project_name}
              onChange={(e) => {
                setState({ ...sortState, project_name: e.target.value });
              }}
            />
          </div>
        </div>
        <div className="item_wrap">
          <div className="item_box">
            <div className="item_head">案件担当店舗</div>
            <Select
              className=""
              value={sortState.project_store_id}
              defaultLabel="指定なし"
              onChange={(v) => setState({
                ...sortState,
                ...changeStore({
                  employeeList,
                  storeId: Number(v),
                  storeKey: 'store_id',
                  returnStoreKey: 'project_store_id',
                  employeeKey: 'project_employee_id',
                }),
              })}
              options={pulldown(storeList)}
            />
          </div>
          <div className="item_box">
            <div className="item_head">案件担当者</div>
            <Select
              className=""
              value={sortState.project_employee_id}
              defaultLabel="指定なし"
              onChange={(v) => setState({ ...sortState, project_employee_id: Number(v) })}
              options={pulldown(
                sortEmployee({
                  employeeList,
                  storeId: sortState.project_store_id,
                  storeKey: 'store_id',
                }),
              )}
            />
          </div>
        </div>
        <div className="item_wrap">
          <div className="item_box">
            <div className="item_head">着工日</div>
            <DatePicker
              date={sortState.construction_date}
              onChange={(v) => setState(
                { ...sortState, construction_date: v },
              )}
            />
          </div>
          <div className="item_box">
            <div className="item_head">完工日</div>
            <DatePicker
              date={sortState.completion_date || null}
              onChange={(v) => setState(
                { ...sortState, completion_date: v },
              )}
            />
          </div>
        </div>
        <div className="item_wrap">
          <div className="item_box">
            <div className="item_head">メンテナンス日</div>
            <DatePicker
              date={sortState.maintenance_date || null}
              onChange={(v) => setState(
                { ...sortState, maintenance_date: v },
              )}
            />
          </div>
        </div>

        <div className="item_wrap">
          <div className="item_box">
            <div className="item_head">タイトル</div>
            <Input
              className=""
              value={sortState.title}
              onChange={(e) => setState({ ...sortState, title: e.target.value })}
            />
          </div>
          <div className="item_box">
            <div className="item_head">対応日</div>
            <DatePicker
              date={sortState.supported_date || null}
              onChange={(v) => setState(
                { ...sortState, supported_date: v },
              )}
            />
          </div>
        </div>
      </div>
      <footer className="base_footer refind_footer">
        <Button
          size="md"
          color="primary"
          onClick={handleClickSearch}
        >絞込み
        </Button>
        <Button
          size="md"
          color="dark"
          onClick={() => dispatch(DialogActions.pop())}
        >キャンセル
        </Button>
      </footer>
    </div>
  );
};
